import Actions from "../actions";
import { produce } from "immer";

const initialState = {
  subscriptionPlans: {},
  selectedSubscriptionPlanLogDetails: {
    selectedCurrentSubscriptionPlanId: "",
    navigateBack: {},
  },
};

const subscriptionPlans = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_SUBSCRIPTION_PLANS_LIST: {
      draft.subscriptionPlans = payload?.subscriptionPlans;
      break;
    }

    case Actions.SELECTED_SUBSCRIPTION_PLAN_LOG_ID: {
      draft.selectedSubscriptionPlanLogDetails = {
        selectedCurrentSubscriptionPlanId:
          payload?.selectedCurrentSubscriptionPlanId,
        navigateBack: payload?.navigateBack,
      };
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default subscriptionPlans;
